import type { Language } from "./types";

export const texts = {
    da: {
        invalidLink: "Ugyldigt link eller bruger ikke fundet.",
        loading: "Loader…",
        eventId: "EventID",
        personId: "PersonID",
        myPage: "Min side",
        shifts: "Mine vagter",
        ticket: "Mad",
        noTicket: "Ingen billetoplysninger fundet.",
        documents: "Information",
        noDocuments: "Ingen dokumenter på eventet.",
        open: "Åbn",
        info: "Info",
        importantInfo: "Vigtig information",
        transport: "Transport",
        transportDescription: "Opret transport-booking for denne person på dette event.",
        createTransport: "Opret transport",
        createDeparture: "Opret departure",
        departureDescription: "Opret en transport booking for departure.",
        mobileTip: "Mobil-tip: Denne side er lavet som kort + accordion, så den er nem på telefon.",
        languageDa: "Dansk",
        languageEn: "English",
        driverRides: "Mine køreture",
        from: "Fra",
        to: "Til",
        vehicle: "Bil",
        flight: "Flight",
        note: "Note",
        unknownContact: "Ukendt kontakt",
        noFilesInSection: "Ingen filer i denne sektion.",
        noTicketFound: "Ingen billet fundet.",
        source: "Kilde",
        used: "Brugt",
        active: "Aktiv",
        airport: "Lufthavn",
        onTheWay: "På vej",
        atPickup: "Ved pickup",
        pickedUp: "Samlet op",
        delivered: "Afleveret",
        planned: "Planlagt",
        drinks: "Drinks",
        myBars: "Dine barer",
        noDrinks: "Ingen drinkoplysninger fundet.",
        drinksRemaining: "Du har {count} drinks tilbage",
        sightseeing: "Sightseeing tour",
        sightseeingDescription: "Book your Sightseeing tour",
        createExperience: "Opret Experience",
        vipParking: "VIP Parkering",
        vipParkingScan: "Scan QR-code VIP parkering",
    },
    en: {
        invalidLink: "Invalid link or logged-in user not found.",
        loading: "Loading…",
        eventId: "Event ID",
        personId: "Person ID",
        myPage: "My page",
        shifts: "My shifts",
        ticket: "Meals",
        noTicket: "No ticket information found.",
        documents: "Information",
        noDocuments: "No event documents.",
        open: "Open",
        info: "Info",
        importantInfo: "Important information",
        transport: "Transport",
        transportDescription: "Book a shuttle transport booking for this person on this event.",
        createTransport: "Book shuttle transport",
        createDeparture: "Create departure",
        departureDescription: "Create a transport booking for departure.",
        mobileTip: "Mobile tip: This page uses cards + accordion, so it works well on phones.",
        languageDa: "Dansk",
        languageEn: "English",
        driverRides: "My rides",
        from: "From",
        to: "To",
        vehicle: "Vehicle",
        flight: "Flight",
        note: "Note",
        unknownContact: "Unknown contact",
        noFilesInSection: "No files in this section.",
        noTicketFound: "No ticket found.",
        source: "Source",
        used: "Used",
        active: "Active",
        airport: "Airport",
        onTheWay: "On the way",
        atPickup: "At pickup",
        pickedUp: "Picked up",
        delivered: "Delivered",
        planned: "Planned",
        drinks: "Drinks",
        myBars: "Your bars",
        noDrinks: "No drink information found.",
        drinksRemaining: "You have {count} drinks left",
        sightseeing: "Sightseeing tour",
        sightseeingDescription: "Book your Sightseeing tour",
        createExperience: "Create Experience",
        vipParking: "VIP Parking",
        vipParkingScan: "Scan QR-code VIP parking",
    },
};

export type Texts = typeof texts[Language];